import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=048b807b&scoped=true&"
import script from "./SectionHeader.vue?vue&type=script&lang=ts&"
export * from "./SectionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=048b807b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b807b",
  null
  
)

export default component.exports